// Define all the routes here and return key in this manner to get default selected route in side bar navigation

const CATALOGUE_PRODUCT_PATHS = [
  "/catalogue/products",
  "/catalogue/brands",
  "/catalogue/suppliers",
  "/catalogue/stores",
  "/catalogue/attributes",
  "/catalogue/categories",
  "/catalogue/inventory",
  "/catalogue/import",
  "/catalogue/excelimport",
];

export const getDefaultOpenKeys = (pathname = "") => {
  if (
    CATALOGUE_PRODUCT_PATHS.some(
      (path) => pathname === path || pathname.startsWith(`${path}/`)
    ) ||
    pathname.startsWith("/catalogue/products/edit")
  ) {
    return ["sub2"];
  }

  if (pathname.startsWith("/orders") || pathname.startsWith("/invoices")) {
    return ["sub3"];
  }

  if (pathname.startsWith("/content/")) {
    return ["sub5"];
  }

  if (
    pathname.startsWith("/user/") ||
    pathname.startsWith("/customers/") ||
    pathname.startsWith("/reviews")
  ) {
    return ["sub4"];
  }

  if (pathname.startsWith("/settings")) {
    return ["sub6"];
  }

  if (pathname.startsWith("/templates")) {
    return ["sub7"];
  }

  if (pathname.startsWith("/mediagallery")) {
    return ["sub8"];
  }

  return [];
};

const getDefaultSelectedRoute = (pathname) => {
  if (pathname.startsWith("/catalogue/products/edit")) {
    return ["5"];
  }

  switch (pathname) {
    case "/dashboard":
      return ["1"];
    case "/catalogue/products":
      return ["5"];
    case "/catalogue/products/add":
      return ["5"];
    case "/catalogue/brands":
      return ["6"];
    case "/catalogue/brands/add":
      return ["6"];
    case "/catalogue/suppliers":
      return ["7"];
    case "/catalogue/stores":
      return ["8"];
    case "/catalogue/attributes":
      return ["9"];
    case "/catalogue/categories":
      return ["10"];
    case "/catalogue/inventory":
      return ["23"];
    case "/catalogue/import":
      return ["34"];
    case "/catalogue/excelimport":
      return ["35"];
    case "/orders":
      return ["11"];
    case "/user/list":
      return ["16"];
    case "/user/add":
      return ["17"];
    case "/user/role":
      return ["18"];
    case "/user/role/add":
      return ["18"];
    case "/settings":
      return ["20"];
    case "/settings/general":
      return ["20"];
    case "/settings/store":
      return ["20"];
    case "/settings/selling":
      return ["20"];
    case "/settings/taxes":
      return ["20"];
    case "/settings/shipping":
      return ["20"];
    case "/settings/product":
      return ["20"];
    case "/settings/invoices":
      return ["20"];
    case "/settings/orders":
      return ["20"];
    case "/settings/tools":
      return ["20"];
    case "/content/pages":
      return ["21"];
    case "/content/news":
      return ["22"];
    case "/templates":
      return ["24"];
    case "/customers/customerslist":
      return ["31"];
    case "/reviews":
      return ["32"];
    case "/mediagallery":
      return ["36"];
    default:
      return ["1"];
  }
};

export default getDefaultSelectedRoute;
